function RestDay(props) {
    return <div className="no-workouts">Ei treenejä</div>;
}

export default RestDay;